import cx from 'classnames';
import { t } from 'i18next';
import { LazyLoadWrapper } from '../../../../../../shared/frontend/components/lazyLoad/LazyLoadWrapper';
import { Link } from '../../../../../../shared/frontend/components/link';
import { TrackedLink } from '../../../../../../shared/frontend/components/link';
import { Media } from '../../../../../../shared/frontend/components/presentational/media';
import { ZoneContainer } from '../../../../../../shared/frontend/components/ads/zone';
import { openGlobalReportModal } from '../../../../../../shared/frontend/components/moderation/GlobalReportModal';
import { useMedia } from '../../../../../../shared/frontend/components/grid/hooks';

/* tslint:disable:no-var-requires */
const WEBSITE_VERSION = require('../../../../../website_version.json');
const BUILD_TAG = require('../../../../../build_tag.json');
/* tslint:enable:no-var-requires */

/* tslint:disable:max-line-length */

const VERSION_STRING = `${WEBSITE_VERSION.version} (${BUILD_TAG.tag})`;

function SiteFooter(props: any) {
  const adjustMedia = useMedia(['(max-width: 830px)'], [true], false);
  const socialMediaMargin = adjustMedia ? 'slds-m-right--small' : 'slds-m-right--small';

  return (
    <div className="rio-footer--bg slds-p-bottom--x-large">
      {props.displayAdsProvider === 'venatus' ? (
        <>
          <Media at="sm">
            <ZoneContainer className="slds-p-around--medium slds-align--absolute-center" type="venatus_mobile_btf" />
          </Media>
          <Media greaterThan="sm">
            <ZoneContainer className="slds-p-around--medium slds-align--absolute-center" type="footer" />
          </Media>
        </>
      ) : (
        <>
          {props.displayAdsProvider !== 'playwire' && (
            <LazyLoadWrapper height={300} offset={400} placeholder={<div />} once>
              <ZoneContainer
                className="rio-hidden--small slds-p-around--medium slds-align--absolute-center"
                type="footer"
              />
            </LazyLoadWrapper>
          )}
        </>
      )}
      <div className="slds-m-top--small slds-grid slds-grid--align-center slds-wrap">
        <div className="slds-size--2-of-4 slds-small-size--2-of-4 slds-medium-size--1-of-4 slds-large-size--1-of-4 text-white slds-text-body--small slds-text-align--left slds-p-horizontal--large slds-p-bottom--small">
          <div className="slds-m-bottom--small">
            <b>Raider.IO</b>
          </div>
          <ul>
            {/* <li>
              <Link to="/raids">{t('common:footer.raid-rankings')}</Link>
            </li> */}
            {/* <li>
              <Link to="/addon">{t('common:footer.addon-and-client')}</Link>
            </li> */}
            <li>
              <Link to="/search">{t('common:footer.advanced-search')}</Link>
            </li>
            <li>
              <TrackedLink href="/api" target="_blank">
                {t('common:footer.developer-api')}
              </TrackedLink>
            </li>
            <li>
              <TrackedLink target="_blank" href={`${RIO_ALL_SITES.wowretail.external_url}/branding`}>
                {t('common:footer.branding-guidelines')}
              </TrackedLink>
            </li>
            <li>
              <TrackedLink target="_blank" href={`${RIO_ALL_SITES.wowretail.external_url}/advertise`}>
                {t('common:footer.advertise')}
              </TrackedLink>
            </li>
          </ul>
        </div>
        <div className="slds-size--2-of-4 slds-small-size--2-of-4 slds-medium-size--1-of-4 slds-large-size--1-of-4 text-white slds-text-body--small slds-text-align--left slds-p-horizontal--large slds-p-bottom--small">
          <div className="slds-m-bottom--small">
            <b>{t('common:footer.community')}</b>
          </div>
          <ul>
            <li>
              <TrackedLink target="_blank" href="https://www.patreon.com/bePatron?u=6788452">
                {t('common:footer.donate')}
              </TrackedLink>
            </li>
            <li>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  openGlobalReportModal();
                }}
              >
                {t('common:footer.feedback')}
              </a>
            </li>
            <li>
              <TrackedLink target="_blank" href="https://support.raider.io">
                {t('common:footer.faq')}
              </TrackedLink>
            </li>
            <li>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  openGlobalReportModal();
                }}
              >
                {t('moderation:button.report')}
              </a>
            </li>
            <li>
              <TrackedLink href={`${RIO_ALL_SITES.wowretail.external_url}/login`}>
                {t('nav:auth.login')} / {t('nav:auth.signup')}
              </TrackedLink>
            </li>
            <li>
              <div className="slds-m-top--x-small slds-text-heading--small">
                <TrackedLink href="https://discord.gg/raider" as="social_footer:discord" className={socialMediaMargin}>
                  <i
                    className="fa-brands fa-discord rio-realm-link nohover"
                    title={t('common:socials.interaction-prompt.discord')}
                  />
                </TrackedLink>
                <TrackedLink
                  href="https://twitter.com/RaiderIO_WoW"
                  as="social_footer:twitter"
                  className={socialMediaMargin}
                >
                  <i
                    className="fa-brands fa-x-twitter rio-realm-link nohover"
                    title={t('common:socials.interaction-prompt.twitter')}
                  />
                </TrackedLink>
                <TrackedLink
                  href="https://youtube.com/@RaiderIO_WoW"
                  as="social_footer:youtube"
                  className={socialMediaMargin}
                >
                  <i
                    className="fa-brands fa-youtube rio-realm-link nohover"
                    title={t('common:socials.interaction-prompt.youtube')}
                  />
                </TrackedLink>
                <TrackedLink
                  href="https://twitch.tv/raiderio_wow"
                  as="social_footer:twitch"
                  className={socialMediaMargin}
                >
                  <i
                    className="fa-brands fa-twitch rio-realm-link nohover"
                    title={t('common:socials.interaction-prompt.twitch')}
                  />
                </TrackedLink>
                <TrackedLink
                  href="https://www.tiktok.com/@raider.io"
                  as="social_footer:tiktok"
                  className={socialMediaMargin}
                >
                  <i
                    className="fa-brands fa-tiktok rio-realm-link nohover"
                    title={t('common:socials.interaction-prompt.tiktok')}
                  />
                </TrackedLink>
                <TrackedLink
                  href="https://www.instagram.com/raiderio_wow/"
                  as="social_footer:instagram"
                  className={socialMediaMargin}
                >
                  <i
                    className="fa-brands fa-instagram rio-realm-link nohover"
                    title={t('common:socials.interaction-prompt.instagram')}
                  />
                </TrackedLink>
                <TrackedLink
                  href="https://facebook.com/raider.io"
                  as="social_footer:facebook"
                  className={socialMediaMargin}
                >
                  <i
                    className="fa-brands fa-facebook rio-realm-link nohover"
                    title={t('common:socials.interaction-prompt.facebook')}
                  />
                </TrackedLink>
              </div>
            </li>
          </ul>
        </div>
        <div className="slds-size--2-of-2 slds-small-size--2-of-2 slds-medium-size--2-of-4 slds-large-size--2-of-4 text-white slds-text-body--small slds-p-horizontal--large">
          {/* <div className="slds-m-bottom--small">
            <b>Looking for work?</b>{' '}
            <TrackedLink href="https://careers.raider.io/" target="_blank" as="careers:footer">
              Raider.IO is hiring!
            </TrackedLink>
          </div> */}

          <div
            className={cx({
              'slds-size--4-of-4': true,
              'slds-text-color--weak': true,
              'slds-text-body--small': true,
              'text-white': true,
              'text-muted': true
            })}
          >
            <p>Raider.IO&reg;, IO Score&reg; &copy; 2017-2025 RaiderIO, Inc. &mdash; v{VERSION_STRING}</p>
            <br />
            <p>
              World of Warcraft, Warcraft and Blizzard Entertainment are trademarks or registered trademarks of Blizzard
              Entertainment, Inc. in the U.S. and/or other countries.
            </p>
            <br />
            <p className="text-muted">
              <TrackedLink
                href={`${RIO_ALL_SITES.wowretail.external_url}/terms-of-use`}
                className="rio-realm-link text-muted"
              >
                {t('common:footer.terms-of-use')}
              </TrackedLink>
              &nbsp; | &nbsp;
              <TrackedLink
                href={`${RIO_ALL_SITES.wowretail.external_url}/privacy-policy`}
                className="rio-realm-link text-muted"
              >
                {t('common:footer.privacy-policy')}
              </TrackedLink>
              &nbsp; | &nbsp;
              <TrackedLink
                href={`${RIO_ALL_SITES.wowretail.external_url}/cookies-policy`}
                className="rio-realm-link text-muted"
              >
                {t('common:footer.cookies-policy')}
              </TrackedLink>
              &nbsp; | &nbsp;
              <TrackedLink
                href={`${RIO_ALL_SITES.wowretail.external_url}/moderation-policy`}
                className="rio-realm-link text-muted"
              >
                Moderation Policy
              </TrackedLink>
              &nbsp; | &nbsp;
              <TrackedLink href={`${RIO_ALL_SITES.wowretail.external_url}/security`} className="rio-realm-link text-muted">
                {t('common:footer.security')}
              </TrackedLink>
            </p>
            <div className="text-muted" id="footer-do-not-sell">
              {props.displayAdsProvider !== 'mediavine' && props.videoAdsProvider !== 'mediavine' && (
                <>
                  CA Residents Only:{' '}
                  <TrackedLink
                    href={`${RIO_ALL_SITES.wowretail.external_url}/privacy-policy#do_not_sell`}
                    className="rio-realm-link text-muted"
                  >
                    Do Not Sell My Personal Information
                  </TrackedLink>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SiteFooter;
